import { useState } from 'react';
import { AnswerForm } from '../components/AnswerForm';
import type { GameModuleProps } from '../types/game';
import { validateModuleAnswer } from '../utils/answers';

export function RiddleModule({ module, onComplete }: GameModuleProps<'riddle'>) {
  const [visibleHints, setVisibleHints] = useState(0);
  return (
    <div className="module-content">
      <AnswerForm prompt={module.config.prompt} placeholder={module.config.placeholder}
        onValidate={(answer) => validateModuleAnswer(module, answer)}
        onSolved={(attempts) => onComplete({ success: true, attempts, data: { hintsUsed: visibleHints } })} />
      {visibleHints < module.config.hints.length && (
        <button className="button button-ghost" onClick={() => setVisibleHints((count) => count + 1)}>Mostrar una pista</button>
      )}
      <div className="hints" aria-live="polite">
        {module.config.hints.slice(0, visibleHints).map((hint, index) => <p key={hint}>Pista {index + 1}: {hint}</p>)}
      </div>
    </div>
  );
}

